export default __webpack_public_path__ + "static/media/spade.98d2844c.ogg";